module.exports = __webpack_public_path__ + "static/media/clue-4.c7766339.svg";